import { useContext, useState } from "react";
import { outputDate, periodAsHumanReadable } from "../utils/date";
import IOAbstract, { EditContext, type IOProps } from "./io-abstract";

//
// We receive strings from database
// But we also build some Date in the Gui
//
export default function IODate(
  props: {
    validation?: (value: Date | undefined) => string;
  } & IOProps<string>
) {
  const editContext = useContext(EditContext);
  const [currentError, setCurrentError] = useState<string | React.ReactNode>(
    ""
  );

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const valueAsDate: Date | undefined = event.target.value
      ? new Date(event.target.value)
      : undefined;

    // Custom validation
    const customMessage = props.validation?.(valueAsDate) ?? "";
    event.target.setCustomValidity(customMessage);

    // validationMessage will hold customMessage
    setCurrentError(event.target.validationMessage);

    props.onChange?.(value);
  };

  return (
    <IOAbstract<string>
      currentError={currentError}
      editContext={editContext}
      type="date"
      renderOutput={
        <>
          <div>{outputDate(props.value)}</div>
          <div data-e2e="excluded">{periodAsHumanReadable(props.value)}</div>
        </>
      }
      renderInput={(uuid) => (
        <input
          id={uuid}
          className="form-control"
          defaultValue={(props.value ?? 0) + ""}
          name={props.name}
          onChange={onChange}
          required={props.required}
          type="date"
          {...props.htmlProps}
        />
      )}
      {...props}
    />
  );
}
